export const environment = {
  production: false,
  supressConsoleLog: false,
  cognitoUserPoolRegion: 'ap-southeast-1',
  cognitoUserPoolId: 'ap-southeast-1_frVXsIbgy',
  cognitoAppClientId: '1p151hon35tm0t4eco2cpt5fm6',
  cognitoIdentityPoolRegion: 'ap-southeast-1',
  cognitoIdentityPoolId: 'ap-southeast-1:446c226a-ce7d-4c7f-8f24-4ff90e4c6d12',
  oauthDomain: 'auth-ap-southeast-1.energie.co.id',
  oauthRedirectSignIn: 'http://localhost:4200',
  oauthRedirectSignOut: 'http://localhost:4200/sign-out',
  appTitle: 'HEI Solar',
  userApiName: 'userapi',
  userApiUrl: 'https://kqp0vnz6l7.execute-api.ap-southeast-1.amazonaws.com',
  lookupApiName: 'lookupapi',
  lookupApiUrl: 'https://krum0vt29f.execute-api.ap-southeast-1.amazonaws.com',
  stationApiName: 'assignapi',
  stationApiUrl: 'https://e24ydqvot9.execute-api.ap-southeast-1.amazonaws.com',
  analyticApiName: 'analytic-api',
  analyticApiUrl: 'https://06fr6k90gd.execute-api.ap-southeast-1.amazonaws.com',
  analysisApiName: 'analysisapi',
  analysisApiUrl: 'https://o7yautssab.execute-api.ap-southeast-1.amazonaws.com',
  weatherApiName: 'weatherapi',
  weatherApiUrl: 'https://ollg9l033g.execute-api.ap-southeast-1.amazonaws.com',
  pushApiName: 'push-api',
  pushApiUrl: 'https://axqvrfnk44.execute-api.ap-southeast-1.amazonaws.com',
  stationGoApiName: 'station-go-api',
  stationGoApiUrl: 'https://slhm812t4k.execute-api.ap-southeast-1.amazonaws.com',
  websocketUrl: 'wss://gqfcqqipse.execute-api.ap-southeast-1.amazonaws.com/prod',
  vapidPublicKey: 'BGBKWU_9GI3zMDyudtuSP17tncSuWSlWCAHX2k6X-V_CLHxDa-Mu7fdyJw33PK0n5E1TwRlm8AESdGygL6cdYu0',
  defaultGridPageSize: 10,
  sesSourceEmailAddress: 'support@energie.co.id',
  allowSignUp: true,
  apiOpenai: 'http://egate-influx.stroomer.id:5000/solar'
  };